export enum FocusPayEntityType {
	"LLC" = "LimitedLiabilityCompany",
	"Corporation" = "PrivateCorporation",
	"Public Corporation" = "PublicCorporation",
	"Sole Proprietorship" = "SoleProprietorship",
	"Registered Partnership" = "Partnership",
	"Not for Profit" = "NonProfit",
	"Financial Institutution" = "FinancialInstitution",
	"Goverment Entity/Municipality" = "Government",

	"Trust" = "Trust",
}
